import { render, staticRenderFns } from "./SPCompanyRegistrationLayout.vue?vue&type=template&id=657994da&scoped=true"
import script from "./SPCompanyRegistrationLayout.vue?vue&type=script&lang=js"
export * from "./SPCompanyRegistrationLayout.vue?vue&type=script&lang=js"
import style0 from "./SPCompanyRegistrationLayout.vue?vue&type=style&index=0&id=657994da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657994da",
  null
  
)

export default component.exports